import React, { createContext, useState, ReactNode } from 'react';
import { ShopProviders } from '~/lib/types/edge-api-types';

interface ShopSearchContextType {
  searchedPostcode: string | null;
  searchedShopProviders: ShopProviders;
  setSearchedPostcode: (postcode: string | null) => void;
  setSearchedShopProviders: (shopProviders: ShopProviders) => void;
}

export const ShopSearchContext = createContext<ShopSearchContextType | undefined>(undefined);

interface ShopSearchProviderProps {
  children: ReactNode;
}
export const ShopSearchProvider: React.FC<ShopSearchProviderProps> = ({ children }) => {
  const [searchedPostcode, setSearchedPostcodeState] = useState<string | null>(null);
  const [searchedShopProviders, setSearchedShopProvidersState] = useState<ShopProviders>({});

  const setSearchedPostcode = (postcode: string | null) => {
    setSearchedPostcodeState(postcode);
  };

  const setSearchedShopProviders = (shopProviders: ShopProviders) => {
    setSearchedShopProvidersState(shopProviders);
  };

  const value: ShopSearchContextType = {
    searchedPostcode,
    searchedShopProviders,
    setSearchedPostcode,
    setSearchedShopProviders
  };

  return <ShopSearchContext.Provider value={value}>{children}</ShopSearchContext.Provider>;
};
